import { render } from "./NuveiCashIn.vue?vue&type=template&id=5cdc30e8&scoped=true"
import script from "./NuveiCashIn.vue?vue&type=script&lang=js"
export * from "./NuveiCashIn.vue?vue&type=script&lang=js"

import "./NuveiCashIn.vue?vue&type=style&index=0&id=5cdc30e8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdc30e8"]])

export default __exports__